import { ACTION_PREFIX } from '../../constants';

export const FOCUS_ACTION = `${ACTION_PREFIX}/FOCUS`;

/**
 *  An action to set focus on the InsurancePicker text box
 */
export const focus = () => ({ type: FOCUS_ACTION });
